<template>
  <input
    ref="input"
    :id="computedID"
    :aria-invalid="state === 'invalid'"
    :aria-required="required ? true : null"
    :autocomplete="autocomplete"
    :disabled="disabled"
    :name="name"
    :pattern="pattern"
    :placeholder="placeholder"
    :readonly="readonly"
    :required="required"
    :type="type"
    :value="value"
    :class="{
      'f-input': true,
      'form-control': true,
      'is-valid': state !== 'invalid',
      'is-invalid': state === 'invalid',
      'is-small': small
    }"
    @input="onInput"/>
</template>
<script>

export default {
  name: 'f-input',
  props: {
    id: {
      type: String,
      default: null,
    },
    autocomplete: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    pattern: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    state: {
      type: [Boolean, String],
      default: null,
      validator: (v) => [null, 'valid', 'invalid', true, false].includes(v)
    },
    type: {
      type: String,
      default: 'text',
      validator: (v) => ['email', 'number', 'password', 'tel', 'text'].includes(v)
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    computedID() {
      if (this.id) {
        return this.id;
      }

      return `dr-input-${this.generateUUID()}`
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    },
    generateUUID () {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // eslint-disable-next-line
        let r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt / 16);
        // eslint-disable-next-line
        return (c === 'x' ? r : (r&0x3|0x8)).toString(16);
      });

      return uuid;
    }
  }
}
</script>
